import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("p", null, "Sorry", -1);

var _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "Requested content not found.", -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_f7_navbar = _resolveComponent("f7-navbar");

  var _component_f7_block = _resolveComponent("f7-block");

  var _component_f7_page = _resolveComponent("f7-page");

  return _openBlock(), _createBlock(_component_f7_page, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_f7_navbar, {
        title: "Not found",
        "back-link": "Back"
      }), _createVNode(_component_f7_block, {
        strong: ""
      }, {
        default: _withCtx(function () {
          return [_hoisted_1, _hoisted_2];
        }),
        _: 1
      })];
    }),
    _: 1
  });
}